document.querySelectorAll('.faq-title').forEach((el, index) => {
  el.textContent = `${index + 1}. ${el.textContent}`;
});
